export const tableHeader = [
  "name",
  "personalDataTemplate",
  "informationSystem",
  "createdAt",
  "updatedAt",
  "createdBy",
  "UpdatedBy",
];
